<template>
  <div class="form-group">
    <input
      @input="updateValue"
      class="form-control mytextwithicon input-field"
      :name="this.name"
      :placeholder="this.placeholder"
      :maxlength="this.maxlength"
      :class="{
        'is-invalid': error && ((validateFields.untouched && !validateFields.dirty) || validateFields.touched),
      }"
      :type="this.type"
      :value="value"
      :disabled="disabled"
      @blur="$emit('blur')"
      @keydown="$emit('keydown', $event)"
      :autocomplete="autocomplete ? 'on' : 'off'"
    />
    <error-box v-if="this.errorBox" :field="this.errorBox" />
    <span
      v-show="error && ((validateFields.untouched && !validateFields.dirty) || validateFields.touched)"
      class="invalid-feedback"
      >{{ error }}</span
    >
    <slot name="inputNoteText"></slot>
  </div>
</template>

<script>
export default {
  props: {
    value: [String, Number],
    name: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    maxlength: {
      type: Number,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      required: false,
    },
    validateFields: {
      type: Object,
    },
    type: {
      type: String,
      default: 'text',
    },
    errorBox: {
      type: String,
      default: null,
    },
    autocomplete: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    updateValue(e) {
      this.$emit('input', e.target.value);
    },
  },
};
</script>
